import axios from "../axios/axios";
import {
  appSetAlert,
  appSetFiscalYear,
  appSetFiscalYears,
  appSetIsDemo,
  appSetSendingRequest,
  setConfirm
} from "../store/actions/appAction";
import { setUser } from "../store/actions/userAction";
import { errorDispatcher, formatNumber } from "../helpers";
import Messages from "../lang/fa/messages";
import { convertToFormdata } from "helpers/dataFormat";
import { setBusiness } from "store/actions/businessAction";

export const apiSetAlert =
  (alertMessage, alertType, alertDisplay = true) =>
    (dispatch, getState) => {
      dispatch(appSetAlert(alertMessage, alertType, alertDisplay));
    };

export const apiRegister = (inputs, navigate, searchParams) => (dispatch, getState) => {
  dispatch(appSetSendingRequest(true));
  axios
    .post("users/registerStep1", inputs)
    .then((registerResponse) => {
      const queryParams = localStorage.getItem("query_Params")
      const json = queryParams !== null ? JSON.parse(queryParams) : {}
      const newParams = {...json,...searchParams}
      axios.post(`analytics/`, inputs, {
        params: {
          ...newParams,
          type: "register"
        }
      })
        .then((analyticsResponse) => {
          localStorage.removeItem("query_Params")

          dispatch(setUser(registerResponse.data.user));
          dispatch(apiSetAlert(registerResponse.data.message, "success", false));
          navigate("/auth/login");
        })
        .catch((error) => {
          errorDispatcher(error, dispatch);
        });

    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    });
};

export const apiLogin = (inputs, isDemo, navigate, searchParams) => (dispatch, getState) => {
  const match = (pass) => {
    let passw = /[۰-۹]/;
    return passw.test(pass)


  }
  const sendLogin = (newInput, callBack) => {
    axios
      .post("users/login", newInput).then(res => {
        callBack(res)
      }).catch(err => {
        callBack(err, true)

      })

  }
  const successLogin = (loginRegister, correctInput, isNeedChangePassword) => {
    if (!loginRegister.data.hasActiveSession) {

      const queryParams = localStorage.getItem("query_Params")
      const json = queryParams !== null ? JSON.parse(queryParams) : {}
      const newParams = {...json,...searchParams}
      axios.post(`analytics/`, correctInput, {
        params: {
          ...newParams,
          type: "login",
        }
      })
        .then((analyticsRegister) => {
          localStorage.removeItem("query_Params")

          dispatch(setUser(loginRegister.data.user));
          if (isDemo) {
            dispatch(appSetIsDemo(true));
          } else {
            dispatch(appSetIsDemo(false));
          }
          if (isNeedChangePassword) {
            dispatch(apiChangePassword({ confirmPassword: formatNumber(inputs.password), password: formatNumber(inputs.password), oldPassword: inputs.password }, loginRegister.data.user.token));
          }
          navigate && navigate("/");
        })
        .catch((error) => {
          errorDispatcher(error, dispatch);
        });
    } else {
      dispatch(appSetSendingRequest(false));
      dispatch(setConfirm("اخطار", async () => {
        dispatch(apiLogoutLatestActiveUser(loginRegister.data.userId))
      }, undefined, `در حال حاضر کاربر فعال در سیستم وجود دارد،آیا اطمینان دارید کاربر فعال از سیستم خارج شود؟`, () => {
      }));
    }
  }
  // return console.log(inputs.password)
  const newInput = { ...inputs, password: formatNumber(inputs.password) }
  sendLogin(newInput, (res, err) => {
    if (err) {
      if (match(inputs.password)) {
        sendLogin(inputs, (res, err) => {
          if (err) {
            errorDispatcher(res, dispatch);

          }
          else {
            successLogin(res, inputs, true)
          }
        })
      } else {
        errorDispatcher(res, dispatch);

      }
    } else {
      successLogin(res, newInput)
    }
  })
  return
  // dispatch(appSetSendingRequest(true));
  // axios
  //   .post("users/login", inputs)
  //   .then((loginRegister) => {
  //     if (!loginRegister.data.hasActiveSession) {


  //       axios.post(`analytics/`, inputs, {
  //         params: {
  //           ...searchParams,
  //           type: "login",
  //         }
  //       })
  //         .then((analyticsRegister) => {
  //           dispatch(setUser(loginRegister.data.user));
  //           if (isDemo) {
  //             dispatch(appSetIsDemo(true));
  //           } else {
  //             dispatch(appSetIsDemo(false));
  //           }
  //           navigate && navigate("/");
  //         })
  //         .catch((error) => {
  //           errorDispatcher(error, dispatch);
  //         });
  //     } else {
  //       dispatch(appSetSendingRequest(false));
  //       dispatch(setConfirm("اخطار", async () => {
  //         dispatch(apiLogoutLatestActiveUser(loginRegister.data.userId))
  //       }, undefined, `در حال حاضر کاربر فعال در سیستم وجود دارد،آیا اطمینان دارید کاربر فعال از سیستم خارج شود؟`, () => {
  //       }));
  //     }
  //   })
  //   .catch((error) => {

  //     errorDispatcher(error, dispatch);
  //   });
};
const apiLogoutLatestActiveUser = (userId) => (dispatch, getState) => {
  axios
    .post("users/deActivesession", { userId })
    .then((res) => {
      dispatch(apiSetAlert(res.data.message, "success", true));

    }).catch(error => errorDispatcher(error, dispatch))
}
export const apiDemoUser = (inputs, searchParams) => (dispatch, getState) => {
  dispatch(appSetSendingRequest(true));
  const queryParams = localStorage.getItem("query_Params")
  const json = queryParams !== null ? JSON.parse(queryParams) : {}
  const newParams = {...json,...searchParams}
  axios
    .post("demoUser/register", inputs)
    .then((demoResponse) => {
      axios.post(`analytics/`, inputs, {

        params: {
          ...newParams,
          type: "demo"
        }
      })
        .then((analyticsResponse) => {
          dispatch(apiLogin(inputs, true));
          localStorage.removeItem("query_Params")
        })
        .catch((error) => {
          errorDispatcher(error, dispatch);
        });
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    });
};

export const apiForgetPassword = (inputs, navigate) => (dispatch, getState) => {
  dispatch(appSetSendingRequest(true));
  axios
    .post("users/forgotPassword", inputs)
    .then((response) => {
      dispatch(apiSetAlert(response.data.message, "success", false));
      navigate("/auth/login");
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    });
};

export const apiConfirmAccount = (verifyCode, user, navigate) => (dispatch, getState) => {
  dispatch(appSetSendingRequest(true));
  axios
    .post("users/verify", verifyCode, {
      headers: { Authorization: `Bearer ${user.token}` }
    })
    .then((response) => {
      dispatch(setUser({ ...user, ...response.data.user }));
      dispatch(apiSetAlert(Messages.accountApproved, "success", false));
      navigate("/");
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    });
};

export const apiRegisterStepTwo = (inputs, token, navigate) => (dispatch, getState) => {
  dispatch(appSetSendingRequest(true));
  axios
    .post("users/registerStep2", inputs, {
      headers: { Authorization: `Bearer ${token}` }
    })
    .then((response) => {
      dispatch(apiSetAlert(Messages.verifyCodeSent, "success"));
      dispatch(appSetSendingRequest(false));
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    });
};

export const apiUpdateProfile =
  (form, token, requestingApi = null, business) =>
    (dispatch, getState) => {
      const formData = convertToFormdata(form);

      axios
        .put("users/update", formData, {
          headers: { Authorization: `Bearer ${token}` }
        })
        .then((response) => {
          dispatch(apiSetAlert(response.data.message, "success"));
          dispatch(setUser({ ...response.data.user, token }));
          dispatch(appSetSendingRequest(false));
        })
        .catch((error) => {
          errorDispatcher(error, dispatch);
        });
    };

export const apiChangePassword =
  (form, token, requestingApi = null) =>
    (dispatch, getState) => {
      const { oldPassword, password, confirmPassword } = form;

      if (password === confirmPassword) {
        const formData = {
          oldPassword,
          password,
          confirmPassword
        };

        dispatch(appSetSendingRequest(true, requestingApi));
        axios
          .put("users/changePassword", formData, {
            headers: { Authorization: `Bearer ${token}` }
          })
          .then((response) => {
            dispatch(apiSetAlert(response.data.message, "success"));
            dispatch(appSetSendingRequest(false));
          })
          .catch((error) => {
            errorDispatcher(error, dispatch);
          });
      } else {
        dispatch(apiSetAlert(Messages.passwordsNotMatch, "error"));
      }
    };

export const apiGetFiscalYears = () => (dispatch, getState) => {
  // dispatch(appSetSendingRequest(true));
  const businessToken = getState()?.businessReducer?.business?.token;
  const fiscalYear = getState()?.appReducer.fiscalYear;
  if (!businessToken) return;
  axios
    .get("/fiscalYears", {
      headers: { Authorization: `Bearer ${businessToken}` }
    })
    .then((response) => {
      const fiscalYears = response.data.fiscalYears;
      dispatch(appSetFiscalYears(fiscalYears));
      // if (!fiscalYear && fiscalYears[0]) {
      //   dispatch(apiGetFiscalYear(fiscalYears[0].id));
      // }
      // dispatch(appSetSendingRequest(false));
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    });
};
export const apiGetFiscalYear = (id) => (dispatch, getState) => {
  if (!id) return;
  dispatch(appSetSendingRequest(true));
  const business = getState()?.businessReducer?.business;
  const businessToken = business?.token;
  if (!businessToken) return;
  axios
    .get(`/fiscalYears/${id}`, {
      headers: { Authorization: `Bearer ${businessToken}` }
    })
    .then((response) => {
      const { fiscalYear, token } = response.data;
      dispatch(appSetFiscalYear({ ...fiscalYear, token }));
      dispatch(setBusiness({
        ...business,
        token,
        fiscalYearTitle: fiscalYear.name,
        fiscalYearStartDate: fiscalYear.start_date,
        fiscalYeaEndDate: fiscalYear.end_date
      }));
      dispatch(appSetSendingRequest(false));
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    });
};

export const apiGetAppSettings = async ({ token }) => {
  const response = await axios({
    method: "get",
    url: "/settings",
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
  return response;
};

function convertObjectToArray(obj) {
  return Object.entries(obj).map(([key, value]) => ({ key, value }));
}

export const apiSetAppSettings = async ({ token, settings }) => {
  const response = await axios({
    method: "post",
    url: "/settings",
    data: { settings: convertObjectToArray(settings) },
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
  // return response;
};

// export const apiUpdateInfo =
//   ({ token, url, modelName, type }) =>
//   (dispatch, getState) => {
//     dispatch(appSetSendingRequest(true));

//     let params = { modelName };
//     if (type) {
//       params.type = type;
//     }
//     const response = axios({
//       method: "get",
//       url: "/settings",
//       params,
//       headers: {
//         Authorization: `Bearer ${token}`,
//       },
//     })
//       .then((response) => {
//         dispatch(apiSetAlert("بروزرسانی با موفقیت انجام شد", "success"));
//       })
//       .catch((error) => {
//         errorDispatcher(error, dispatch);
//       })
//       .finally(() => {
//         dispatch(appSetSendingRequest(false));
//       });
//   };

export const apiUpdateInfo =
  ({ token, url, modelName, type }) =>
    (dispatch, getState) => {
      if (!url) return;
      dispatch(appSetSendingRequest(true));
      let params = { modelName };
      if (type) {
        params.type = type;
      }
      axios
        .get(`${url}`, {
          headers: { Authorization: `Bearer ${token}` },
          params
        })
        .then((response) => {
          dispatch(apiSetAlert("بروزرسانی با موفقیت انجام شد", "success"));
        })
        .catch((error) => {
          errorDispatcher(error, dispatch);
        });
    };

export const apiLogout =
  (token, businessToken) =>
    (dispatch, getState) => {
      dispatch(appSetSendingRequest(true));
      axios
        .post("users/logout", {
          headers: { Authorization: `Bearer ${token}` },
          params: { token, businessToken }
        }, {
          headers: { Authorization: `Bearer ${token}` }
        })
        .then((response) => {
          dispatch(apiSetAlert("خروج از حساب با موفقیت انجام شد", "success"));
        })
        .catch((error) => {
          errorDispatcher(error, dispatch);
        });
    };
